/** Display-only fallback when admin_tier is missing on legacy docs. */
export type AdminTier = "primary" | "nested" | "tourist" | "";

export const ADMIN_TIER_ENUM = {
  primary: "Primary",
  nested: "Nested",
  tourist: "Tourist",
} as const;

export function computeAdminTierFallback(values: {
  level?: string;
  type_code?: string | null;
  parent_level?: string | null;
}): AdminTier {
  if (values.level !== "administrative_division") return "";
  const typeCode = String(values.type_code ?? "").toLowerCase();
  if (typeCode === "tourist_region") return "tourist";
  if (values.parent_level === "country") return "primary";
  if (values.parent_level === "administrative_division") return "nested";
  return "";
}
